import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "layer deletAlt msgDivision" }
const _hoisted_2 = {
  class: "layerMain",
  style: {"max-height":"400px","overflow-y":"auto"}
}
const _hoisted_3 = {
  key: 0,
  class: "layerMainTitle"
}
const _hoisted_4 = { class: "overflow timeSelectArea" }
const _hoisted_5 = { class: "left mgR15" }
const _hoisted_6 = ["onUpdate:modelValue", "onChange"]
const _hoisted_7 = {
  key: 1,
  class: "retimeBlock"
}
const _hoisted_8 = { class: "right" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "layerBtnArea" }
const _hoisted_11 = { class: "layer deletAlt" }
const _hoisted_12 = { class: "layerMain" }
const _hoisted_13 = { class: "mgB10" }
const _hoisted_14 = { class: "mgB10" }
const _hoisted_15 = { class: "layerBtnArea" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "layerTitle" }, "문자 메시지 분활 발송", -1)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.tmpl, (r) => {
          return (_openBlock(), _createElementBlock("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.dist_list.filter(x => x.SEND_NO == r.SEND_NO), (r1) => {
              return (_openBlock(), _createElementBlock("span", null, [
                (r1.ROW_NO==1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(r.SEND_NO) + "회차 : " + _toDisplayString(r1.SEND_DA2) + "(" + _toDisplayString(r1.DATENAME) + ") " + _toDisplayString(r.TM), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (r1.ROW_NO==1)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "date",
                          "onUpdate:modelValue": ($event: any) => ((r1.SEND_DA2) = $event),
                          onChange: ($event: any) => ($options.change_date(r1))
                        }, null, 40, _hoisted_6)), [
                          [_vModelText, r1.SEND_DA2]
                        ])
                      : _createCommentVNode("", true),
                    _createTextVNode(" (" + _toDisplayString(r1.DATENAME) + ") ", 1),
                    (r1.ROW_NO > 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(r1.SEND_DA2), 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(r.CUST_SEND_TM), 1)
                  ]),
                  _createTextVNode(" " + _toDisplayString(r1.IS_SMT == 1 ? "폰발송" : "코인발송") + " ", 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("input", {
                      type: "text",
                      value: r1.SEND_CNT,
                      readonly: "",
                      style: {"width":"50px"}
                    }, null, 8, _hoisted_9),
                    _cache[6] || (_cache[6] = _createTextVNode("건 ", -1))
                  ]),
                  _cache[7] || (_cache[7] = _createTextVNode("    ", -1))
                ])
              ]))
            }), 256))
          ]))
        }), 256)),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "grayBox" }, " 클릭하여 회차별 발송 시작 일자를 수정하실 수 있습니다 ", -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.tmpl_info_save()))
        }, "확인"),
        _cache[9] || (_cache[9] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.is_view_dist=false))
        }, "취소")
      ])
    ], 512), [
      [_vShow, $data.is_view_dist]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "layerTitle" }, "알림", -1)),
      _createElementVNode("div", _hoisted_12, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "layerMainText" }, [
          _createElementVNode("span", { class: "bold red" }, " 폰발송 가능 건수를 초과 "),
          _createTextVNode("하였습니다. "),
          _createElementVNode("br"),
          _createElementVNode("br"),
          _createElementVNode("span", { class: "bold" }, "초과한 건"),
          _createTextVNode("에 대해서 웹발송을 하거나 "),
          _createElementVNode("br"),
          _createTextVNode(" 다른 날짜에 폰발송을 예약하실 수 있습니다. ")
        ], -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "mgR05",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.api.send_type) = $event)),
              value: 2
            }, null, 512), [
              [_vModelRadio, $data.api.send_type]
            ]),
            _cache[11] || (_cache[11] = _createTextVNode("다른 날짜에 폰발송 예약 (무료)", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "mgR05",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.api.send_type) = $event)),
              value: 3
            }, null, 512), [
              [_vModelRadio, $data.api.send_type]
            ]),
            _cache[12] || (_cache[12] = _createTextVNode("당일 폰발송가능건 외 잔여건 코인발송(부분유료)", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.dist_view()))
        }, "확인"),
        _cache[14] || (_cache[14] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($data.is_view_alert=false))
        }, "취소")
      ])
    ], 512), [
      [_vShow, $data.is_view_alert]
    ])
  ], 64))
}